module.exports = "/_next/static/images/tile3-4308a545d266079633b0085e53c13259.png";